import { useEffect, useRef } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Nav } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import NAVSLOT_QUERY from '../cms/nav/queries/NAVSLOT_QUERY';
import useIsExpanded from '../hooks/useIsExpanded'
import useIsMobile from "../hooks/useIsMobile"
import useIsOrgInfoLoading from "../hooks/useIsOrgInfoLoading"

const DrawerNav = () => {
    const parentRef = useRef<HTMLDivElement>(null);
    const childRef = useRef<HTMLDivElement>(null);
    const expanded = useIsExpanded();
    const isMobile = useIsMobile();
    const isOrgLoading = useIsOrgInfoLoading();
    const getState = () => {
        if (expanded) {
            return isMobile ? 'min-vh-100 collapse show' : 'collapse show';
        } else {
            return 'collapse';
        }
    };
    useEffect(() => {
        let parent;
        let child;
        if (parentRef.current) {
            parent = parentRef.current;
        }

        if (childRef.current) {
            child = childRef.current;
        }
        if (child && parent && expanded) {
            child.style.top = parent.offsetTop + 'px';
            child.style.width = parent.offsetWidth + 'px';
        }
    }, [parentRef, childRef, expanded, isOrgLoading]);

    const { data: slot } = useQuery(NAVSLOT_QUERY, {
        variables: {
            navSlotSlug: 'drawer-nav',
        }
    });
    const renderItems = () => {
        const items = slot?.navigation?.menu?.items;
        if (items) {
            return items.map((i: any) => <LinkContainer key={i.id} to={i.uri}><Nav.Link>{i.label}</Nav.Link></LinkContainer>)
        }
        return null;
    }
    return <div className={`col-12 col-lg-2 ${getState()}`} ref={parentRef}>
        <div className="position-fixed h-100 p-3" style={{ backgroundColor: '#e7ecef', zIndex: 100, overflowY: 'auto' }} ref={childRef}>
            {slot?.navigation?.menu?.name ? <h3>{slot?.navigation?.menu?.name}</h3> : null}
            <Nav className="flex-column">
                {renderItems()}
            </Nav>
        </div>
    </div>;
}

export default DrawerNav;